"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresignRequestDtoMediaTypeEnum = void 0;
exports.instanceOfPresignRequestDto = instanceOfPresignRequestDto;
exports.PresignRequestDtoFromJSON = PresignRequestDtoFromJSON;
exports.PresignRequestDtoFromJSONTyped = PresignRequestDtoFromJSONTyped;
exports.PresignRequestDtoToJSON = PresignRequestDtoToJSON;
exports.PresignRequestDtoToJSONTyped = PresignRequestDtoToJSONTyped;
/**
 * @export
 */
exports.PresignRequestDtoMediaTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    Audio: 'AUDIO',
    Document: 'DOCUMENT',
    Thumbnail: 'THUMBNAIL',
    Other: 'OTHER'
};
/**
 * Check if a given object implements the PresignRequestDto interface.
 */
function instanceOfPresignRequestDto(value) {
    if (!('mediaType' in value) || value['mediaType'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('fileSizeBytes' in value) || value['fileSizeBytes'] === undefined)
        return false;
    return true;
}
function PresignRequestDtoFromJSON(json) {
    return PresignRequestDtoFromJSONTyped(json, false);
}
function PresignRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'mediaType': json['mediaType'],
        'mimeType': json['mimeType'],
        'fileSizeBytes': json['fileSizeBytes'],
        'originalFileName': json['originalFileName'] == null ? undefined : json['originalFileName'],
        'checksumSha256': json['checksumSha256'] == null ? undefined : json['checksumSha256'],
    };
}
function PresignRequestDtoToJSON(json) {
    return PresignRequestDtoToJSONTyped(json, false);
}
function PresignRequestDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'mediaType': value['mediaType'],
        'mimeType': value['mimeType'],
        'fileSizeBytes': value['fileSizeBytes'],
        'originalFileName': value['originalFileName'],
        'checksumSha256': value['checksumSha256'],
    };
}
